import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
export function AboutSection() {
  const missionPoints = ['From complexity to clarity in leadership thinking', 'From isolation to trusted strategic partnership', 'From carrying it alone to developing other leaders'];
  return <section className="pt-16 md:pt-24 pb-16 md:pb-24 bg-warm-gray overflow-hidden" data-id="element-12">
      <div className="max-w-[1200px] mx-auto px-6 md:px-12" data-id="element-13">
        {/* Section Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center mb-14" data-id="element-14">
          <div className="flex items-center justify-center gap-4 mb-4" data-id="element-15">
            <div className="w-10 h-[1.5px] bg-gold" data-id="element-16" />
            <span className="font-heading font-bold text-[11px] text-gold uppercase tracking-[0.1em]" data-id="element-17">
              About Me
            </span>
            <div className="w-10 h-[1.5px] bg-gold" data-id="element-18" />
          </div>
          <h2 className="text-[36px] md:text-[44px] mb-3 tracking-[-0.02em]" data-id="element-19">
            Dr. Greg Schaller
          </h2>
          <p className="font-heading font-medium text-[17px] text-gold uppercase tracking-[0.08em]" data-id="element-20">
            Leadership Coach · Coaching Educator
          </p>
        </motion.div>

        {/* Photo + Text Row */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start mb-16" data-id="element-21">
          {/* Photo */}
          <motion.div initial={{
          opacity: 0,
          x: -24
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.9,
          ease: 'easeOut'
        }} className="lg:col-span-5" data-id="element-22">
            <div className="relative max-w-[400px] mx-auto lg:mx-0" data-id="element-23">
              <div className="absolute top-5 -left-5 w-full aspect-[3/4] rounded-xl border-2 border-gold/40" data-id="element-24" />
              <div className="absolute -top-3 -right-3 w-10 h-10 border-t-2 border-r-2 border-gold z-20" data-id="element-25" />
              <div className="absolute -bottom-3 -left-3 w-10 h-10 border-b-2 border-l-2 border-gold z-20" data-id="element-26" />
              <div className="relative aspect-[3/4] rounded-xl overflow-hidden shadow-xl shadow-charcoal/10 z-10" data-id="element-27">
                <img src="https://cdn.magicpatterns.com/uploads/n9F6eRR9oRhHL64HogWnUy/8173_-_Square.png" alt="Dr. Greg Schaller" className="w-full h-full object-cover object-top" data-id="element-28" />
              </div>
            </div>

            {/* Gold accent bar */}
            <div className="relative z-10 flex items-center gap-4 mt-8 max-w-[400px] mx-auto lg:mx-0" data-id="element-29">
              <div className="h-[2px] flex-1 bg-gold/30" data-id="element-30" />
              <span className="font-heading font-bold text-[17px] text-gold uppercase tracking-[0.12em]" data-id="element-31">
                30+ Years of Leadership Impact
              </span>
              <div className="h-[2px] flex-1 bg-gold/30" data-id="element-32" />
            </div>
          </motion.div>

          {/* Text */}
          <motion.div initial={{
          opacity: 0,
          x: 24
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.9,
          delay: 0.2,
          ease: 'easeOut'
        }} className="lg:col-span-7 flex flex-col" data-id="element-33">
            <div className="space-y-5 text-[16px] leading-[1.75] mb-12" data-id="element-34">
              <p data-id="element-35">
                I work with entrepreneurs, founding partners, and senior
                executives who carry real leadership responsibility and want to
                lead with greater clarity and effectiveness.
              </p>
              <p data-id="element-36">
                Through Leadership Capacity Coaching, I help leaders step back
                from complexity, think clearly about what matters most, and move
                forward with confident decisions and focused action.
              </p>
              <p data-id="element-37">
                My approach brings together strategic thinking, emotional
                intelligence, and professional coaching so leaders gain clarity,
                strengthen relationships, and develop other leaders around them.
              </p>
              <p data-id="element-38">
                I also founded the Leaders Who Coach Academy, where leaders
                develop professional coaching skills and learn to build coaching
                cultures inside their organizations.
              </p>
              <p data-id="element-39">
                Over 30 years, I have coached and trained leaders across
                multiple countries and leadership contexts, from startups to
                global organizations.
              </p>
            </div>

            <div className="text-center" data-id="element-40">
              <Button variant="secondary" data-id="element-41">Meet Dr. Greg Schaller</Button>
            </div>
          </motion.div>
        </div>

        {/* Mission Section — Full Width Below */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.8,
        delay: 0.3,
        ease: 'easeOut'
      }} className="bg-white border-l-2 border-gold rounded-xl p-8 md:p-10" data-id="element-42">
          <h3 className="text-[20px] mb-6" data-id="element-43">My Mission</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-44">
            {missionPoints.map((point, index) => <div key={index} className="flex items-start gap-4" data-id="element-45">
                <span className="w-8 h-8 rounded-full bg-gold/10 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-46">
                  <span className="text-gold text-sm" data-id="element-47">✦</span>
                </span>
                <span className="text-[16px] leading-[1.65]" data-id="element-48">{point}</span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}